$(() => {
    let insghtLandingSection = $('.bs-section--insight-landing');
    let innerMenu = $('.bs-section--insight-landing .inner-menu');
    let featuredPost = $('.bs-posts__featured .bs-post__details .bs-post__date');
    let featuredPostMain = $('.bs-posts__featured');

    if(insghtLandingSection.length > 0){
        console.log('inner menu', innerMenu);
        featuredPost.prepend('<span class="separator"> Featured</span>');
        $(innerMenu).insertAfter(featuredPostMain);
    }
});